<template>
  <div class="helpUserBox">
      <div class="helpcloginCon">
          <div class="bigTitle" @click="backFn('showa')"><span ></span>充值与购买套餐</div>
          <div v-if="showa">
              <h3>充值余额</h3>
              <div class="smallTile" v-for="(item,index) in flowList" >
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div>
               <h3>购买套餐</h3>
              <div class="smallTile" v-for="(item,index) in flowListq" >
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div>
          </div>
          <div class="bigTitle" @click="backFn('showb')"><span ></span>账号安全设置</div>
          <div v-if="showb">
              <h3>修改登录密码</h3>
              <div class="smallTile" v-for="(item,index) in setloginList">
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div> 
              <h3>设置/修改签约密码</h3>
              <div class="smallTile" v-for="(item,index) in setsignList">
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div> 
              <h3>设置/修改绑定手机号</h3>
              <div class="smallTile" v-for="(item,index) in setphotoList">
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div> 
              <h3>设置/修改绑定邮箱</h3>
              <div class="smallTile" v-for="(item,index) in setemailList">
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div> 
          </div>
          <div class="bigTitle" @click="backFn('showc')"><span ></span>费用记录</div>
          <div class="smallTile" v-for="(item,index) in payList" v-if="showc">
                <p>{{item}} </p>
          </div> 
          <div class="bigTitle"  @click="backFn('showd')"><span></span>上传手写签名</div>
          <div v-if="showd">
              <h3>上传本地签章</h3>
              <div class="smallTile" v-for="(item,index) in  chapterList" >
                  <p>{{item.con}} </p>
                  <img :src="item.img" v-if="item.img!=''">
              </div>
              <h3>上传手写签名</h3>
              <div class="smallTile" v-for="(item,index) in  writeList" >
                  <p>{{item.con}} </p>
                  <img :src="item.img" v-if="item.img!=''">
              </div>
          </div>
          <div class="bigTitle" @click="backFn('showe')"><span ></span>授权管理</div>
          <div v-if="showe">
            <h3>全部授权</h3>
            <div class="smallTile" v-for="(item,index) in allList">
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
            </div> 
            <h3>合同授权</h3>
            <div class="smallTile" v-for="(item,index) in contractList" >
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
            </div>
          </div>   
          <div class="bigTitle" @click="backFn('showf')"><span></span>签约方管理</div>
          <div class="smallTile" v-for="(item,index) in signtrunList" v-if="showf">
                <p>{{item.con}} </p>
                <img :src="item.img" v-if="item.img!=''">
              </div>
      </div>
  </div>
</template>
<script>
  export default {
    data(){
      return{
        showa:false,
        showb:false,
        showc:false,
        showd:false,
        showe:false,
        showf:false,
        flowList:[
          {
            con:'1.用户中心-费用管理-充值',
            img:''
          },
          {
            con:'2.余额充值，输入要充值的金额',
            img:''
          },
          {
            con:'3.选择支付方式，微信或支付宝',
            img:require('../../../assets/images/helpCenter/cz.jpg')
          },
          {
            con:'4.点击充值',
            img:''
          },
          {
            con:'5.进入费用管理查看余额',
            img:''
          },
        ],
        flowListq:[
          {
            con:'1.用户中心-费用管理-充值',
            img:''
          },
          {
            con:'2.选择要购买的套餐',
            img:require('../../../assets/images/helpCenter/gmtc.jpg')
          },
          {
            con:'3.点击购买',
            img:''
          },
          {
            con:'4.进入费用管理查看合同套餐',
            img:''
          },
        ],
        setloginList:[
          {
            con:'1.用户中心-安全设置',
            img:''
          },
          {
            con:'2.修改登录密码',
            img:require('../../../assets/images/helpCenter/setlogin.png')
          },
          {
            con:'3.输入旧的登录密码',
            img:''
          },
          {
            con:'4.输入新的登录密码',
            img:''
          },
          {
            con:'5.确认新的登录密码',
            img:''
          },
          {
            con:'6.点击提交',
            img:''
          }
        ],
        setsignList:[
          {
            con:'1.用户中心-安全设置',
            img:''
          },
          {
            con:'2.设置/修改签约密码',
           img:require('../../../assets/images/helpCenter/setsign.png')
          },
          {
            con:'3.输入旧的签约密码',
            img:''
          },
          {
            con:'4.输入新的签约密码',
            img:''
          },
          {
            con:'5.确认新的签约密码',
            img:''
          },
          {
            con:'6.点击提交',
            img:''
          },
        ],
        setphotoList:[
          {
            con:'1.用户中心-安全设置',
            img:''
          },
          {
            con:'2.设置/修改绑定手机号',
            img:require('../../../assets/images/helpCenter/bdsjh.png')
          },
          {
            con:'3.输入手机号',
            img:''
          },
          {
            con:'4.获取验证码',
            img:''
          },
          {
            con:'5.点击提交',
            img:''
          },
        ],
        setemailList:[
          {
            con:'1.用户中心-安全设置',
            img:''
          },
          {
            con:'2.设置/修改绑定邮箱',
            img:require('../../../assets/images/helpCenter/bdmail.png')
          },
          {
            con:'3.输入邮箱',
            img:''
          },
          {
            con:'4.获取验证码',
            img:''
          },
          {
            con:'5.点击提交',
            img:''
          }
        ],
        payList:['1.用户中心-费用管理','2.点击消费记录','3.点击充值记录','4.充值'],
        chapterList:[
          {
            con:'1.用户中心-签章管理',
            img:''
          },
          {
            con:'2.我的签章，点击上传签章',
            img:require('../../../assets/images/helpCenter/scqz.png')
          },
          {
            con:'3.上传本地签章',
            img:''
          },
          {
            con:'4.待审核',
            img:''
          },
          {
            con:'5.审核完成',
            img:''
          },
        ],
        writeList:[
          {
            con:'1.用户中心-签章管理',
            img:require('../../../assets/images/helpCenter/scsx.png')
          },
          {
            con:'2.点击手写签名',
            img:require('../../../assets/images/helpCenter/sxq.png')
          },
          {
            con:'3.手机扫描二维码，手写签名',
            img:''
          },
          {
            con:'4.点击保存',
            img:''
          },
          {
            con:'5.上传完成',
            img:''
          },
        ],
        allList:[
          {
            con:'1.用户中心-授权管理',
            img:''
          },
          {
            con:'2.全部授权',
            img:require('../../../assets/images/helpCenter/allsq.png')
          },
          {
            con:'3.点击添加代理人',
            img:require('../../../assets/images/helpCenter/tjdlr.png')
          },
          {
            con:'4.输入被授权人手机号或邮箱-确定',
            img:''
          },
          {
            con:'5.勾选授权签章',
            img:''
          },
          {
            con:'6.点击确认',
            img:''
          },
          {
            con:'7.授权成功',
            img:''
          },
        ],
        contractList:[
          {
            con:'1.用户中心-授权管理',
            img:''
          },
          {
            con:'2.合同授权',
            img:require('../../../assets/images/helpCenter/htsq.png')
          },
          {
            con:'3.选择合同-授权',
            img:''
          },
          {
            con:'4.输入被授权人手机号或邮箱-确定',
            img:''
          },
          {
            con:'5.勾选授权签章',
            img:''
          },
          {
            con:'6.点击确认',
            img:''
          },
          {
            con:'7.授权成功',
            img:''
          },
        ],
        signtrunList:[
          {
            con:'1.用户中心-签约方管理',
            img:''
          },
          {
            con:'2.点击新增',
            img:require('../../../assets/images/helpCenter/addSignuser.png')
          },
          {
            con:'3.输入手机号或有点',
            img:''
          },
          {
            con:'4.点击提交',
            img:''
          },
          {
            con:'5.新增签约方成功',
            img:''
          },
        ]
      }
    },
    methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
  }
</script>
<style lang="scss">
.helpUserBox{
  h3{
    font-size: 13px;
    text-indent: 10px;
    color:rgb(120,120,120);
    margin-top:20px;
  }
  h3:first-child{
    margin-top:0;
  }
}
</style>
